import { createSlice } from "@reduxjs/toolkit";

import {
  getEventThunk,
  createEventThunk,
  updateEventThunk,
  deleteEventThunk,
} from "state/action/event";

// Initial state
const initialState = {
  // Get Event inisial state
  getEvent: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Event inisial state
  createEvent: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Event inisial state
  updateEvent: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Event inisial state
  deleteEvent: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  createEventInputBody: {
    agreementTemplateNumber: "",
    title: "",
    units: "",
    description: "",
    allDay: "",
    start: "",
    end: "",
    location: "",
    tenant: "",
  },
  // Event object value
  event_object_value: "",
};

export const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    setGetEventObjectValue: (state, action) => {
      return {
        ...state,
        event_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetEventObjectValue: (state, _) => {
      return {
        ...state,
        event_object_value: "",
      };
    },
    setClearGetEvent: (state, _) => {
      return {
        ...state,
        getEvent: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setCreateEventInputBody: (state, action) => {
      return {
        ...state,
        createEventInputBody: action.payload,
      };
    },
    setClearCreateEventInputBody: (state, _) => {
      return {
        ...state,
        createEventInputBody: {
          agreementTemplateNumber: "",
          title: "",
          units: "",
          description: "",
          allDay: "",
          start: "",
          end: "",
          location: "",
          tenant: "",
        },
      };
    },
    setClearCreateEvent: (state, _) => {
      return {
        ...state,
        createEvent: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateEvent: (state, _) => {
      return {
        ...state,
        updateEvent: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteEvent: (state, _) => {
      return {
        ...state,
        deleteEvent: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllEventState: (state, _) => {
      return {
        ...state,
        // Get Event inisial state
        getEvent: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Event inisial state
        createEvent: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Event inisial state
        updateEvent: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Event inisial state
        deleteEvent: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Event object value
        event_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Event reducer
      .addCase(getEventThunk.pending, (state, _) => {
        return {
          ...state,
          getEvent: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getEventThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getEvent: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getEventThunk.rejected, (state, action) => {
        return {
          ...state,
          getEvent: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Event reducer
      .addCase(createEventThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createEventThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createEventThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Event reducer
      .addCase(updateEventThunk.pending, (state, _) => {
        return {
          ...state,
          updateEvent: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateEventThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateEvent: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateEventThunk.rejected, (state, action) => {
        return {
          ...state,
          updateEvent: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const eventAction = {
  ...eventSlice.actions,
  getEventThunk,
  createEventThunk,
  updateEventThunk,
  deleteEventThunk,
};

export function selectEventObjectValue(state) {
  return state?.event?.event_object_value;
}

export function selectEvent(state) {
  return state?.event;
}

export default eventSlice.reducer;
